/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EvaluationSubjectGoalInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EvaluationSubjectGoalApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'EvaluationSubjectGoals');
  }

  getEvaluationSubjectGoalsForBook(bookId: number): Observable<EvaluationSubjectGoalInterface[]> {
    const path = `getEvaluationSubjectGoalsForBook/${bookId}`;
    return this.get(path);
  }
}
